/**
 * @module lib/lang Language level utilities
 */

export const defn = (fnName, fnDef) => Object.defineProperty(fnDef, 'name', { value: fnName });
